module.exports = __webpack_public_path__ + "img/pic_xingsz.d24bfda7.png";